import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Modal } from 'antd';
import StripePaymentIntentForm, {} from "./StripePaymentIntentForm";
const StripePurchaseModal = ({ open, title, onCreatePaymentIntent, returnUrl, onPurchaseComplete, onCancel }) => {
    const formRef = useRef(null);
    const [ready, setReady] = useState(false);
    const submit = () => {
        formRef.current?.submit();
    };
    return (_jsx(Modal, { title: title, open: open, onCancel: onCancel, onOk: submit, okButtonProps: {
            disabled: !ready
        }, cancelButtonProps: {
            disabled: !ready
        }, confirmLoading: !ready, destroyOnHidden: true, okText: "Purchase", children: open &&
            _jsx(StripePaymentIntentForm, { ref: formRef, returnUrl: returnUrl, onReady: () => setReady(true), onCreatePaymentIntent: onCreatePaymentIntent, onPaymentSuccess: onPurchaseComplete }) }));
};
export default StripePurchaseModal;
